import React, { Dispatch, SetStateAction } from "react";
import { Box, Button, Modal, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { generateResponsiveStyle } from "../utils/modalStyle";

type props = {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  handleDelete: () => void;
  title?: string;
  message?: string;
};

const DeleteConfirmModal = ({ 
  open, 
  setOpen, 
  handleDelete, 
  title = "Are you sure you want to delete?", 
  message = "This action cannot be undone." 
}: props) => {
  const style = generateResponsiveStyle();
  
  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <div style={{ position: "relative", marginTop: 20 }}>
          <div
            className="cross_icn_logout"
            style={{ display: "flex", justifyContent: "end" }}
          >
            <CloseIcon
              sx={{ cursor: "pointer" }}
              onClick={() => setOpen(false)}
            />
          </div>
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            sx={{ textAlign: "center", fontSize: "19px" }}
          >
            {title}
          </Typography>
          <Typography
            id="modal-modal-description"
            sx={{ textAlign: "center", fontSize: "14px", color: "#666", mt: 1 }}
          >
            {message}
          </Typography>
          <div
            className="flexDiv"
            style={{
              display: "flex",
              justifyContent: "center",
              paddingTop: "25px",
            }}
          >
            <Button
              sx={{
                border: "1px solid #ffdc60",
                textTransform: "capitalize",
                marginInline: "15px",
              }}
              className="btn btn_primary"
              onClick={() => {
                setOpen(false);
                handleDelete();
              }}
            >
              Yes
            </Button>

            <Button
              sx={{
                border: "1px solid #ffdc60",
                textTransform: "capitalize",
                marginInline: "15px",
              }}
              className="btn btn_primary"
              onClick={() => setOpen(false)}
            >
              No
            </Button>
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default DeleteConfirmModal;
